import { render, staticRenderFns } from "./Progressbar.vue?vue&type=template&id=be0b8aaa&scoped=true&"
import script from "./Progressbar.vue?vue&type=script&lang=js&"
export * from "./Progressbar.vue?vue&type=script&lang=js&"
import style0 from "./Progressbar.vue?vue&type=style&index=0&id=be0b8aaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0b8aaa",
  null
  
)

export default component.exports